import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, Plus, Search, ChevronRight, HardHat } from 'lucide-react';
import { clients } from '../data/mockData';

const Clients = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');

  const filtered = clients.filter((c) =>
    c.nom.toLowerCase().includes(search.toLowerCase()) ||
    c.codeMarche.toLowerCase().includes(search.toLowerCase()) ||
    c.ville?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Clients (Marches)</h1>
          <p className="page-subtitle">Gestion des marches publics et de leurs chantiers associes</p>
        </div>
        <button className="btn-primary">
          <Plus size={16} /> Nouveau client
        </button>
      </div>

      <div className="toolbar">
        <div className="search-input grow">
          <Search size={16} />
          <input
            placeholder="Rechercher un client ou un code marche"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <table className="data-table clickable">
            <thead>
              <tr>
                <th>Client</th>
                <th>Code marche</th>
                <th>Type</th>
                <th>Contact</th>
                <th>Chantiers</th>
                <th>Avancement moyen</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c) => {
                const avgAvancement = c.chantiers.length
                  ? Math.round(c.chantiers.reduce((sum, ch) => sum + ch.avancement, 0) / c.chantiers.length)
                  : 0;
                return (
                  <tr
                    key={c.id}
                    className="hoverable clickable"
                    onClick={() => navigate(`/clients/${c.id}`)}
                  >
                    <td>
                      <div className="cell-strong">
                        <Briefcase size={16} className="cell-icon" />
                        <div>
                          <p>{c.nom}</p>
                          <span className="meta-line">{c.adresse}</span>
                        </div>
                      </div>
                    </td>
                    <td><span className="mono">{c.codeMarche}</span></td>
                    <td><span className="badge badge-info">{c.typeMarche}</span></td>
                    <td>
                      <p>{c.contact}</p>
                      <span className="meta-line">{c.email}</span>
                    </td>
                    <td>
                      <span className="chip chip-sky">
                        <HardHat size={11} /> {c.chantiers.length}
                      </span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div className="progress" style={{ width: 120 }}>
                          <div className="progress-bar" style={{ width: `${avgAvancement}%` }} />
                        </div>
                        <span className="mono">{avgAvancement}%</span>
                      </div>
                    </td>
                    <td style={{ width: 28 }}>
                      <ChevronRight size={16} className="arrow-muted" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {filtered.length === 0 && (
            <div className="empty-state">
              <Briefcase size={28} />
              <p>Aucun client ne correspond a votre recherche.</p>
            </div>
          )}
        </div>
      </div>

      <p className="meta-line" style={{ marginTop: '1rem' }}>
        {filtered.length} client(s) affiche(s). Cliquez sur une ligne pour consulter la fiche detaillee.
      </p>
    </div>
  );
};

export default Clients;
